/** 章节小说原文审核结论；审核只读，不展示正文版本采用或脱敏 Diff。 */
import type { ProjectChapter } from '~/data/queries';
import { Drawer } from '~/ui/Dialog';
import { ProjectState } from './landing-project-display';

export function LandingChapterReviewDrawer({
  chapter,
  onClose,
}: { chapter: ProjectChapter; onClose: () => void }) {
  const status = chapter.review_status;
  const result = ['PASSED', 'ISSUES', 'STALE'].includes(status) ? chapter.review_result : null;
  const label = 'AI 审核';
  return (
    <Drawer
      title={`${label}结果`}
      subtitle={`第 ${chapter.chapter_index} 章 · ${chapter.title}`}
      onClose={onClose}
      footer={
        <button type="button" className="btn" onClick={onClose}>
          关闭
        </button>
      }
    >
      <div className="vstack" style={{ padding: 18, gap: 12 }}>
        <div className="hstack">
          <strong>{label}</strong>
          <ProjectState status={status} label={status === 'STALE' ? '待重新审核' : undefined} />
        </div>
        <p className="muted">
          新提交审核使用小说原文及原文参考，不改写营销副本；历史结论保留执行时输入。词库后处理与 AI
          脱敏的正文修改请查看对应日志 / Diff。
        </p>
        {status === 'STALE' && (
          <p role="alert">审核结果已过期，以下已有结论仅供参考，请重新审核。</p>
        )}
        {status === 'FAILED' && (
          <p role="alert" style={{ color: 'var(--neg)' }}>
            {chapter.error ?? '本阶段执行失败，请查看执行记录。'}
          </p>
        )}
        {['PENDING', 'RUNNING'].includes(status) && <p>本阶段正在后台处理，尚无本次完成结论。</p>}
        {result ? (
          <>
            <p>
              违规词 {result.illegal_words.length} 项 · 违规句 {result.illegal_phrases.length} 项
            </p>
            {!result.illegal_words.length && !result.illegal_phrases.length && <p>未发现问题</p>}
            {result.illegal_words.map((item, index) => (
              <div key={`word-${index}`} className="card-flat" style={{ padding: 12 }}>
                <span className="muted">违规词 · {item.illegal_type}</span>
                <blockquote dir="auto" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                  {item.word}
                </blockquote>
              </div>
            ))}
            {result.illegal_phrases.map((item, index) => (
              <div key={`phrase-${index}`} className="card-flat" style={{ padding: 12 }}>
                <span className="muted">违规句 · {item.illegal_type}</span>
                <blockquote dir="auto" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                  {item.phrase}
                </blockquote>
              </div>
            ))}
          </>
        ) : (
          !['PENDING', 'RUNNING', 'FAILED'].includes(status) && <p>暂无本阶段审核结论</p>
        )}
      </div>
    </Drawer>
  );
}
